const routes = {
  login: '/login',
  root: '/',
  home: '/home',
  countries: '/countries',
  storesCountry: '/countries/:countryId/stores',
  createStore: '/create-store',
  managers: '/managers',
  collections: '/collections',
  markets: '/markets',
  factories: '/factories',
  regions: '/regions',
  cities: '/cities',
  citiesRegion: '/region/:regionId',
  cityStores: '/city/:cityId/stores',
  store: '/store/:storeId',
  requests: '/requests',
  editStore: '/edit-store/:storeId',
  adminManagers: '/admin/managers',
  adminSoap: '/admin/soap',
  report: '/report',
};

export { routes };



// WEBPACK FOOTER //
// ./src/Routes/config.ts